export const TYPE_OPTIONS = [
  { value: 'COMMUNITY', label: 'Comunidade' },
  { value: 'CREATOR', label: 'Criador' },
  { value: 'FORMAT', label: 'Formato' },
  { value: 'TREND', label: 'Tendência' },
  { value: 'AESTHETIC', label: 'Estética' },
  { value: 'SUBJECT', label: 'Assunto' },
] as const

export const TOAST_SUCCESS = {
  title: 'Post atualizado',
  description: 'As informações do post foram atualizadas com sucesso.',
}

export const TOAST_ERROR = {
  title: 'Erro ao atualizar',
  description: 'Não foi possível atualizar o post. Tente novamente.',
}
